// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1UFXt","noInteraction":"EventWrapper_noInteraction__1t00b"};